"use client";
import { useState, type ReactNode } from "react";
import type { StorefrontProduct } from "./types";
import type { StorefrontFeatures } from "../features";
import { orderedVariants, productImageForSelection } from "./variant-presentation";
import { galleryForVariant, productForVariant } from "./product-variants";
import { VariantSelector } from "./VariantSelector";

export function VariantCard({ product, mode, locale, children, swatchColors = {}, initialVariant = "first", labels, disabled = false }: {
  disabled?: boolean;
  initialVariant?: "first" | "none";
  labels?: StorefrontFeatures["labels"];
  swatchColors?: Record<string, string>;
  product: StorefrontProduct; mode: StorefrontFeatures["inlineVariants"]; locale?: string;
  children: (product: StorefrontProduct, controls: ReactNode) => ReactNode;
}) {
  const [id, setId] = useState("");
  const enabled = mode !== "none" && product.productType === "variable" && !product.configurator && !product.requiresConfiguration;
  const variants = orderedVariants(product);
  const effectiveId = id || (initialVariant === "first" ? product.variantId ?? variants[0]?.id ?? "" : "");
  const selected = enabled ? product.variants.find((variant) => variant.id === effectiveId) : undefined;
  const display: StorefrontProduct = selected ? {
    ...productForVariant(product, selected), productType: "simple", variants: [selected],
    imageUrl: galleryForVariant(product, selected.id)[0]?.src ?? productImageForSelection(product, selected.id, initialVariant),
  } : { ...product, imageUrl: productImageForSelection(product, undefined, initialVariant) };
  const controls = enabled ? <VariantSelector product={product} value={effectiveId} onChange={setId} locale={locale} mode={mode} initialVariant={initialVariant} swatchColors={swatchColors} labels={labels} disabled={disabled} wholeVariants disableUnavailable /> : null;
  return children(display, controls);
}
